// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__9Tcwn","greyed-out":"styles_greyed-out__eUv0E","traitsList":"styles_traitsList__GBqvm"};